import { Box, Stack } from '@mui/joy'
import { useStore } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { usePermissions } from '~/entities/common/viewer'
import { Alert } from '~/shared/ui/Alerts'
import { Button } from '~/shared/ui/Buttons'
import { Modal, useModal } from '~/shared/ui/Modal'
import { forceApprove, forceApproveFx } from './model'

export function ForceApprove() {
  const { t } = useTranslation()
  const { canForceApproveDrivers } = usePermissions()

  const { isModalShow, closeModal, openModal } = useModal()

  const isForceApprovePending = useStore(forceApproveFx.pending)

  const handleOnOk = () => {
    forceApprove({ closeModal })
  }

  return (
    <>
      <Button
        onClick={openModal}
        show={canForceApproveDrivers}
        variant='yellow'
      >
        {t('button.force approve')}
      </Button>

      <Modal
        title={t('force approve title')}
        isShow={isModalShow}
        onCancel={closeModal}
        dialogProps={{
          sx: {
            minWidth: '600px',
            maxWidth: '600px',
          },
        }}
      >
        <Box sx={{ padding: '4px' }}>
          <Alert variant='warning'>{t('alert.force approve warning')}</Alert>

          <br />

          <Stack direction='row' justifyContent='space-between' spacing={2}>
            <Button
              variant='gray'
              fullWidth
              onClick={closeModal}
              disabled={isForceApprovePending}
            >
              {t('button.cancel')}
            </Button>
            <Button
              variant='yellow'
              fullWidth
              onClick={handleOnOk}
              loading={isForceApprovePending}
            >
              {t('button.force approve')}
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  )
}
